import geovos from "./geovos-template.config"
import intusi from "./intusi-template.config"
export default {
  intusi,
  geovos,
}
